import DraftImageStore from '../../persistence/DraftImageStore'
import {updateNodes} from '../../editorActions'

/**
 * Restore blob URLs for image nodes from IndexedDB after loading a draft.
 * Also populates runtime.pendingImageFiles for the Save flow.
 * @param {object} runtime
 * @param {string} draftId - The draft id to load images from
 */
export async function restoreDraftImages(runtime, draftId) {
    if (!runtime?.getState || !runtime?.dispatch) return

    const state = runtime.getState()
    if (!state?.nodes) return

    // Collect nodes that need image restoration
    const imageEntries = [...state.nodes].filter(([, node]) => {
        const src = node.content?.src ?? node.style?.src
        return src && (src.startsWith('blob:') || src.startsWith('data:'))
    })

    // Load all images from IndexedDB in parallel
    const results = await Promise.allSettled(
        imageEntries.map(async ([nodeId]) => {
            const file = await DraftImageStore.load(draftId, nodeId)
            return file ? {nodeId, file} : null
        }),
    )

    // Build batch updates and populate pendingImageFiles
    const entries = []
    for (const result of results) {
        if (result.status !== 'fulfilled' || !result.value) continue
        const {nodeId, file} = result.value
        const newBlobUrl = URL.createObjectURL(file)
        entries.push({nodeId, updates: {content: {src: newBlobUrl}}})
        runtime.pendingImageFiles?.set(nodeId, file)
    }

    if (entries.length > 0) {
        runtime.dispatch(updateNodes(entries, {recordHistory: false}))
    }
}
